/**
 * Simple store for workflow step activities.
 * Stored separately from React state to avoid re-renders when activity changes.
 * Only the StepActivity component subscribes to updates.
 */

type ActivityListener = () => void

class WorkflowActivityStore {
  private activities = new Map<string, string>()
  private listeners = new Map<string, Set<ActivityListener>>()

  setActivity(stepId: string, activity: string | null): void {
    if (activity === null) {
      this.activities.delete(stepId)
    } else {
      this.activities.set(stepId, activity)
    }
    // Only notify listeners for this specific step
    this.listeners.get(stepId)?.forEach(listener => listener())
  }

  getActivity(stepId: string): string | null {
    return this.activities.get(stepId) || null
  }

  subscribe(stepId: string, listener: ActivityListener): () => void {
    if (!this.listeners.has(stepId)) {
      this.listeners.set(stepId, new Set())
    }
    this.listeners.get(stepId)!.add(listener)
    return () => this.listeners.get(stepId)?.delete(listener)
  }

  clear(): void {
    this.activities.clear()
  }
}

export const workflowActivityStore = new WorkflowActivityStore()
